<template>
  <span>{{computedLabel}}</span>
</template>

<style scoped>
span {
  font-weight:700;
  margin-left:1.5em;
  margin-right:1em
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop, Inject } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppFormLabel extends AppComponent {
  // 上位のフォームコンポーネントで公開されたフォームデータを参照
  @Inject('_app_form') form;

  @Prop({ required: true })
  prop;

  get schema () {
    return this.form.schema;
  }

  // ラベル取得
  get computedLabel () {
    if ((this.schema !== null) &&
      (this.schema.props) &&
      (this.prop in this.schema.props) &&
      ('label' in this.schema.props[this.prop])) {
      return this.schema.props[this.prop].label;
    } else {
      return null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppFormLabel.vue